import styled from 'styled-components';

import { Actionbar, Flexbox } from '@ibinder/ui-common-core';

export const StyledActionbar = styled(Actionbar)`
  height: 3rem;
  z-index: 3;
`;

export const ActionbarContent = styled(Flexbox)`
  justify-content: end;
  width: 100%;
`;

export const PopOutContainer = styled.div`
  & > div > div > div > div {
    padding-right: 0;
    button {
      width: 100%;
    }
  }
`;

export const PopupButton = styled(Flexbox)`
  width: 100%;
  align-items: center;
  padding-right: 1rem;
  color: ${({ theme }) => theme.colors.primary};
`;
